export default __webpack_public_path__ + "static/media/fullHand.58c2ead1.png";